import rocketAnimation from 'assets/gif/rocket.gif'

type TProps = {
  label: string | JSX.Element
}

const RocketPlaceholder = ({ label }: TProps) => {
  return (
    <section className="rocket-placeholder">
      <img
        src={rocketAnimation}
        alt="space rocket launch animation"
        className="rocket-placeholder__image"
      />
      <p className="rocket-placeholder__label">{label}</p>
    </section>
  )
}

export default RocketPlaceholder
